/**
 * Single source of truth for the "legal advice on non-reserved matters"
 * statement. Imported by the on-site notice component, the shared email
 * notice and any form acknowledgement copy so messaging never drifts.
 */

/** Short one-sentence version, used inline in body copy. */
export const NON_RESERVED_STATEMENT =
  "We provide legal information and legal advice on non-reserved matters, and we prepare legal opinions. We are not an admitted attorney firm, so we do not take on reserved work or represent clients in court.";

/** Full version used in disclaimers, emails and footers. */
export const NON_RESERVED_FULL =
  "Nkadimeng Danny Legal and Compliance Support provides legal information and legal advice on non-reserved matters, and prepares legal opinions. We are not a firm of admitted attorneys, so we do not undertake work reserved by the Legal Practice Act 28 of 2014 and we do not represent clients in court.";

/** Heading used above the full statement. */
export const NON_RESERVED_HEADING = "Scope of our advice";

/** Checkbox label shown on enquiry and booking forms. */
export const NON_RESERVED_ACKNOWLEDGEMENT =
  "I confirm that I have read and understood that Nkadimeng Danny Legal and Compliance Support provides legal advice on non-reserved matters only, and does not undertake reserved work or represent clients in court.";
